import { Link, useRouteError } from 'react-router-dom';

import Button from './ui/button';

const ErrorBoundary = () => {
  const error = useRouteError();

  return (
    <div className="flex h-screen flex-col items-center justify-center p-4 text-center text-white">
      <h1 className="text-2xl font-bold">Something went wrong.</h1>
      <small className="text-slate-500">{error.message}</small>

      <p className="mt-3">Please try again later or</p>
      <Link to="/">
        <Button variant="link">go to homepage</Button>
      </Link>
    </div>
  );
};

export default ErrorBoundary;
